(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atelier-animated-entrance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atelier-entrance')) {
    customElements.define('atelier-entrance', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-animated') || this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.picture = this.querySelector('.eb-atelier-face');
        this.pause = this.querySelector('[data-pause]');
        this.started = false;
        this.visible = false;
        this.classList.add('is-enhanced');
        const ready = () => this.picture?.complete && this.picture.naturalWidth > 0;
        const play = () => {
          if (this.started || !this.visible || document.hidden || this.reduced.matches || !ready()) return;
          this.started = true;
          this.classList.add('is-armed');
          this.frame = requestAnimationFrame(() => {
            this.frame = requestAnimationFrame(() => this.classList.add('is-playing'));
          });
        };
        const syncVisibility = () => {
          this.classList.toggle('is-offscreen', !this.visible || document.hidden);
          play();
        };
        const syncMotion = () => {
          this.classList.toggle('is-reduced', this.reduced.matches);
          if (this.reduced.matches) {
            cancelAnimationFrame(this.frame);
            this.classList.remove('is-armed', 'is-playing', 'is-paused');
            this.started = false;
          } else play();
        };
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          syncVisibility();
        }, { threshold: .25 });
        this.observer.observe(this.querySelector('.eb-atelier-clock'));
        this.picture?.addEventListener('load', play, { signal });
        this.picture?.addEventListener('error', () => {
          this.classList.remove('is-armed', 'is-playing', 'is-enhanced');
        }, { signal });
        this.querySelector('[data-replay]')?.addEventListener('click', () => {
          cancelAnimationFrame(this.frame);
          this.classList.remove('is-playing', 'is-armed', 'is-paused');
          this.pause.setAttribute('aria-pressed', 'false');
          this.pause.setAttribute('aria-label', this.pause.dataset.pauseLabel);
          this.pause.firstElementChild.textContent = 'Ⅱ';
          this.started = false;
          void this.offsetWidth;
          play();
        }, { signal });
        this.pause?.addEventListener('click', () => {
          const paused = this.classList.toggle('is-paused');
          this.pause.setAttribute('aria-pressed', String(paused));
          this.pause.setAttribute('aria-label', paused ? this.pause.dataset.resumeLabel : this.pause.dataset.pauseLabel);
          this.pause.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
        }, { signal });
        document.addEventListener('visibilitychange', syncVisibility, { signal });
        this.reduced.addEventListener('change', syncMotion, { signal });
        syncMotion();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.abort = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
